<div class="actions">
  <ul class="actions-list" *ngIf="workOrder$ | async as workOrder">
    <li class="actions-item" *ngIf="assignVisible$ | async">
      <button
        mat-icon-button
        aria-label="Opens the 'Assign Specialists' Pane."
        matTooltip="{{
          'workorder.card-actions.assign-specialists' | translate
        }}"
        matTooltipPosition="above"
        onclick="this.blur()"
        (click)="openAssign(workOrder)"
      >
        <mat-icon>group_add</mat-icon>
      </button>
    </li>
    <li class="actions-item" *ngIf="(isSupervisor$ | async) && (notMineVisible$ | async)">
      <button
        mat-icon-button
        aria-label="Opens the 'Work Order Not Mine' Pane."
        matTooltip="{{
          'workorder.card-actions.workorder-notMine' | translate
        }}"
        matTooltipPosition="above"
        onclick="this.blur()"
        (click)="openNotMine(workOrder)"
      >
        <mat-icon>report_problem</mat-icon>
      </button>
    </li>
    <li class="actions-item" *ngIf="employeeVisitsVisible$ | async">
      <button
        mat-icon-button
        aria-label="Opens the 'Employee Visits' Pane."
        matTooltip="{{ 'workorder.card-actions.employee-visits' | translate }}"
        matTooltipPosition="above"
        onclick="this.blur()"
        (click)="openEmployeeVisits(workOrder)"
      >
        <mat-icon>access_time</mat-icon>
      </button>
    </li>
    <li class="actions-item" *ngIf="optimizeVisible$ | async">
      <button
        mat-icon-button
        aria-label="Optimize Work Order."
        matTooltip="{{ 'workorder.card-actions.optimize' | translate }}"
        matTooltipPosition="above"
        onclick="this.blur()"
        (click)="openWorkOrderOptimize(workOrder)"
      >
        <mat-icon>done_all</mat-icon>
      </button>
    </li>
    <li class="actions-item" *ngIf="workOrderIsFinished$ | async">
      <button
        mat-icon-button
        aria-label="Extra Time."
        matTooltip="{{ 'workorder.card-actions.extra-time' | translate }}"
        matTooltipPosition="above"
        onclick="this.blur()"
        (click)="openWorkOrderExtraTime(workOrder)"
      >
        <mat-icon>access_time</mat-icon>
      </button>
    </li>
    <li class="actions-item" *ngIf="workOrderIsFinished$ | async">
      <button
        mat-icon-button
        aria-label="Reject Work Order."
        matTooltip="{{ 'workorder.card-actions.reject' | translate }}"
        matTooltipPosition="above"
        onclick="this.blur()"
        (click)="openRejectWorkOrder(workOrder)"
      >
        <mat-icon>cancel</mat-icon>
      </button>
    </li>
    <li class="actions-item" *ngIf="workOrderIsFinished$ | async">
      <button
        mat-icon-button
        aria-label="Validate Work Order."
        matTooltip="{{ 'workorder.card-actions.validate' | translate }}"
        matTooltipPosition="above"
        onclick="this.blur()"
        (click)="openValidateWorkOrder(workOrder)"
      >
        <mat-icon>check_circle_outline</mat-icon>
      </button>
    </li>
    <li class="actions-item" *ngIf="workOrderIsValidated$ | async">
      <b>{{ "workorder.card-actions.validated-on" | translate }}</b>
      {{ workOrder.closeDate | date : "d/MM/YYYY" }}
    </li>
  </ul>
</div>
